<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="login.email"
                label="E-mail"
                name="login"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>

              <v-text-field
                @keyup.enter="loginNow"
                id="password"
                v-model="login.password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="error"
            class="error--text mt-n10 mb-n4"
          >Der skete en fejl. Tjek dine input.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading" @click="loginNow">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Login",
  methods: {
    loginNow() {
      this.error = null;
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.login.email, this.login.password)
        .then(data => {
          console.log(data);
          this.$store.dispatch("getUserData");
          this.loading = false;
          this.$router.replace("/");
        })
        .catch(error => {
          this.loading = false;
          this.error = error;
          console.log("error", error);
        });
    }
  },
  data() {
    return {
      error: null,
      loading: false,
      login: { email: "", password: "" }
    };
  }
};
</script>

<style lang="scss" scoped></style>
